var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThumbsUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 34"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M27.5 34H10.833V12.333L22.5.667l2.083 2.083q.293.292.48.792t.187.958v.583l-1.833 7.25H32.5q1.334 0 2.333 1t1 2.334V19a3.4 3.4 0 0 1-.25 1.25l-5 11.75q-.375.834-1.25 1.417T27.5 34m-20-21.667V34H.833V12.333z"
})));
export default SvgThumbsUp;